import {audits} from '../services'
import {fetch as fetchRaw} from '@lib/fetch'
import {getDefinedUrlSearchParams} from '@lib/util'

const fetch = (url, ...args) => fetchRaw([audits.url, url], ...args)

export function auditsGet(queryParams) {
  return fetch(`/v1/audits?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function auditsNetworkGet(queryParams) {
  return fetch(`/v1/audits?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function auditFindingCreate(body) {
  return fetch(`/v1/audit-findings`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function auditFindingPatch(id, body) {
  return fetch(`/v1/audit-findings/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function auditFindingBulkRemove(body) {
  return fetch(`/v1/audit-findings/bulk-remove`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  })
}

export function auditGet(id) {
  return fetch(`/v1/audits/${id}`, {
    method: 'GET',
  })
}

export function auditsGetAdmin(queryParams) {
  return fetch(`/v1/admin/audits?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function auditCreate(body) {
  return fetch(`/v1/audits`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function auditVersionsGet(auditId, queryParams) {
  return fetch(`/v1/audits/${auditId}/versions?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function auditsPatch(id, body) {
  return fetch(`/v1/audits/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function auditsUpdate(id, body) {
  return fetch(`/v1/audits/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
}

export function getAdminAuditTypes(queryParams) {
  return fetch(`/v1/admin/audit-types?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function deleteAuditType({id}) {
  return fetch(`/v1/admin/audit-types/${id}`, {
    method: 'DELETE',
  })
}
export function updateAuditTypeUsage({id, deprecate}) {
  return fetch(`/v1/admin/audit-types/${id}/usage`, {
    method: 'PATCH',
    body: JSON.stringify({deprecate}),
  })
}

export function createAuditType(body) {
  return fetch(`/v1/admin/audit-types`, {method: 'POST', body: JSON.stringify(body)})
}

export function patchAuditType(id, body) {
  return fetch(`/v1/admin/audit-types/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function getAuditTypes(queryParams) {
  return fetch(`/v1/audit-types?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function auditRequestsGet(id, queryParams) {
  return fetch(`/v1/audit-access-requests/${id}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function auditBulkArchive(body) {
  return fetch(`/v1/audits/bulk-archive`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function auditBulkUnarchive(body) {
  return fetch(`/v1/audits/bulk-unarchive`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function auditRequest(id) {
  return fetch(`/v1/audits/${id}/request`, {
    method: 'POST',
  })
}

export function getAssessments(queryParams) {
  return fetch(`/v1/slcp-assessments?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function fetchAssessments() {
  return fetch(`/v1/slcp-assessments/fetch-assessments`, {
    method: 'POST',
  })
}

export function getAssessmentAttachmentLink(id) {
  return fetch(`/v1/slcp-assessments/${id}/attachment`, {
    method: 'GET',
  })
}

export function getAssessmentById(id) {
  return fetch(`/v1/slcp-assessments/${id}`, {
    method: 'GET',
  })
}

export function createSlcpAssessmentHistory(body) {
  return fetch(`/v1/slcp-assessments/history`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getAdminSlcpAnalytics(queryParams) {
  return fetch(`/v1/admin/slcp/analytics?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}